var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CommunicationsEvent, CommunicationsEventKind, ContentCommunicationHandler } from '../communications/index';
/**
 * @inheritdoc
 */
var CrossWindowContentCommunicationHandler = /** @class */ (function (_super) {
    __extends(CrossWindowContentCommunicationHandler, _super);
    /**
     * Constructor.
     *
     * @param communicationsManager A communications manager.
     * @param methods The callback to dispose the content.
     */
    function CrossWindowContentCommunicationHandler(communicationsManager, methods) {
        var _this = _super.call(this, communicationsManager, methods) || this;
        _this.iframeId = '';
        _this.messageQueue = [];
        return _this;
    }
    /**
     * @inheritdoc
     */
    CrossWindowContentCommunicationHandler.prototype.disposeCore = function () {
        this.messageQueue = [];
        _super.prototype.disposeCore.call(this);
    };
    /**
     * @inheritdoc
     */
    CrossWindowContentCommunicationHandler.prototype.handleEventCore = function (e) {
        if (!this.iframeId) {
            this.attemptHandShake(e);
            return;
        }
        _super.prototype.handleEventCore.call(this, e);
    };
    /**
     * @inheritdoc
     */
    CrossWindowContentCommunicationHandler.prototype.send = function (message) {
        if (this.iframeId) {
            message.contentId = this.iframeId;
        }
        else {
            if (message.kind !== CommunicationsEventKind.Mounted) {
                // In case we do not have an iframeId push all events to queue,
                // only Mounted are allowed to establish handshake.
                this.messageQueue.push(message);
                return;
            }
        }
        _super.prototype.send.call(this, message);
    };
    /**
     * Attempt a handshake with the container.
     *
     * @param e The communication event.
     */
    CrossWindowContentCommunicationHandler.prototype.attemptHandShake = function (e) {
        if (e.contentId) {
            // Phase 2 of the handshake - we got the id.
            this.iframeId = e.contentId;
            // Send it again to notify parent.
            var response = new CommunicationsEvent(CommunicationsEventKind.Mounted);
            response.contentId = this.iframeId;
            this.send(response);
            // Send the previously queued messages.
            this.flushMessages();
        }
        else {
            // Phase 1 of the handshake - we got the hash so send it back.
            var response = new CommunicationsEvent(CommunicationsEventKind.Mounted);
            response.contentId = this.iframeId;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            response.data = e.data;
            this.send(response);
        }
    };
    /**
     * Flush all the messages that were enqueued before the handshake.
     */
    CrossWindowContentCommunicationHandler.prototype.flushMessages = function () {
        for (var _i = 0, _a = this.messageQueue; _i < _a.length; _i++) {
            var msg = _a[_i];
            msg.contentId = this.iframeId;
            this.send(msg);
        }
    };
    return CrossWindowContentCommunicationHandler;
}(ContentCommunicationHandler));
export { CrossWindowContentCommunicationHandler };
//# sourceMappingURL=contentCommunicationHandler.js.map